import type React from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import * as rhf from "react-hook-form";
import type * as z from "zod";

interface UseFormParams<
  TInput extends rhf.FieldValues,
  TOutput extends rhf.FieldValues,
> {
  schema: z.ZodType<TOutput, z.ZodTypeDef, TInput>;
  values: TInput;
  onSubmit: (values: TOutput) => void;
  onError?: () => void;
}

export interface UseFormReturn<TInput extends rhf.FieldValues> {
  control: rhf.Control<TInput, unknown>;
  formState: rhf.FormState<TInput>;
  watch: rhf.UseFormWatch<TInput>;
  handleSubmit: (e: React.BaseSyntheticEvent) => void;
  reset: () => void;
}

export function useForm<
  TInput extends rhf.FieldValues,
  TOutput extends rhf.FieldValues,
>({
  schema,
  values,
  onSubmit,
  onError,
}: UseFormParams<TInput, TOutput>): UseFormReturn<TInput> {
  const { handleSubmit, ...form } = rhf.useForm<TInput, unknown, TOutput>({
    values,
    resolver: zodResolver(schema),
  });

  return {
    ...form,
    handleSubmit: handleSubmit(onSubmit as any, onError),
  };
}
